/* RESPONSIBLE TEAM: team-channels */
import IntegrateBaseController from 'embercom/controllers/apps/app/integrations-hub/integrate-base-controller';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { restartableTask } from 'ember-concurrency-decorators';
import { tracked } from '@glimmer/tracking';
import type Store from '@ember-data/store';
import { action } from '@ember/object';

export default class OauthTokensController extends IntegrateBaseController {
  @service declare appService: $TSFixMe;
  @service declare intl: IntlService;
  @service declare notificationsService: $TSFixMe;
  @service declare store: Store;

  @tracked showCreateApiTokenModal = false;

  declare model: $TSFixMe;
  declare titleToken: string;

  queryParams = [];

  get oauthTokens() {
    return this.model;
  }

  get showTable() {
    return this.model.length > 0;
  }

  get emptyState() {
    return !this.showTable;
  }

  @restartableTask
  *revoke(oauthToken: $TSFixMe) {
    try {
      yield oauthToken.destroyRecord();
    } catch (err) {
      this.notificationsService.notifyError(this.intl.t('account.oauth-tokens.revoke-error'));
    }
  }

  @action
  async refreshOauthTokens() {
    this.model = await this.store.findAll('oauth-tokens', { reload: true });
  }
}
